// extracted by mini-css-extract-plugin
export default {"maxBuyingAmount":"GeHsa","maxBuyingAmount__text":"oQSXP","maxBuyingAmount__amount":"sSuR6","maxBuyingAmount__currency":"Gq4xh"};